import {
  ArrowRightOutlined,
  DeleteFilled,
  EditOutlined,
  ExportOutlined,
  EyeOutlined,
  PlusCircleFilled,
  SyncOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Row,
  Col,
  Input,
  Radio,
  Button,
  Space,
  Table,
  Tag,
  Tooltip,
  Popconfirm,
  Card,
  message,
  Select,
  Dropdown,
  Menu,
} from "antd";
import { useEffect, useState } from "react";
import printJS from "print-js";
import "../Pages/CSS/DonnesBases.css";
import "../Pages/CSS/Traitement.css";
import { SpecialitesService } from "../Services/SpecialitesService";
import { ListFournisService } from "../Services/ListFournisService";
import EditFournisseur from "./Modal/EditFournisseur";
import { Link, useNavigate } from "react-router-dom";
import { DemandeAgrService } from "../Services/DemandeAgrService";
import * as XLSX from "xlsx";
import moment from "moment";
import { printpdf } from '../Services/PrintService';

const ListFournis = ({ onShowCreaFournDiv }) => {
  const navigate = useNavigate();
  const initialTableData = [];

  const [totalFournisseurs, setTotalFournisseurs] = useState(0);
  const [specialites, setSpecialites] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [selectedRowForEdit, setSelectedRowForEdit] = useState(null);
  const [selectedType, setSelectedType] = useState("");
  const [showCreateDivButton, setShowCreateDivButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("d");
  const [searchText, setSearchText] = useState("");
  const [tableData, setTableData] = useState(initialTableData);
  const [filteredData, setFilteredData] = useState(initialTableData);
  const listFournisService = new ListFournisService();
  const specialitesService = new SpecialitesService();
  const demandeAgrService = new DemandeAgrService();


  const userProfil = localStorage.getItem("role_name");

  const fetchData = async () => {
    setLoading(true);
    try {
      const data = await listFournisService.getAllListFournis();
      setTableData(data);
      setFilteredData(data);
      setTotalFournisseurs(data.length); // Mise à jour initiale du total fournisseurs
    } catch (error) {
      message.error("Erreur lors du chargement des données");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (specialites.length === 0) {
      specialitesService
        .getAllSpecialites()
        .then((data) => {
          setSpecialites(data);
        })
        .catch((error) => {
          console.error("Erreur lors du chargement des spécialités :", error);
        });
    }
  }, []);

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const handleResetAll = async () => {
    setSearchText("");
    await fetchData();
  };

  const handleShowCreaFournDiv = () => {
    onShowCreaFournDiv();
  };

  const handleEdit = async (record) => {
    try {
      const fetchedRecord = await demandeAgrService.getOneDemandeAgr(record.numFourn);
      setSelectedRowForEdit(fetchedRecord);
      setEditModalVisible(true);
    } catch (error) {
      message.error("Erreur lors de la récupération du fournisseur");
    }
  };

  const handleDelete = async (record) => {
    try {
      await demandeAgrService.supDemandeAgr(record.numFourn);
      message.success("Fournisseur supprimé avec succès");
      await fetchData();
    } catch (error) {
      message.error("Erreur lors de la suppression du fournisseur");
    }
  };

  const getColumnKeys = () =>
    columns
      .filter((col) => col.dataIndex)
      .map((col) => col.dataIndex)
      .filter((key) => key !== "created_by" && key !== "actions");

  const handleExport = () => {
    const columnsToUse = getColumnKeys();
    const selectedData = filteredData.map((row) =>
      columnsToUse.reduce((acc, colKey) => {
        acc[colKey] = row[colKey];
        return acc;
      }, {})
    );

    const worksheet = XLSX.utils.json_to_sheet(selectedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, "Liste_Fournisseurs_de_soins.xlsx");
  };

  const handleExportPdf = () => {
    const columnsToUse = getColumnKeys();

    const dataToExport = filteredData.map((row) =>
      columnsToUse.reduce((acc, key) => {
        acc[key] = row[key];
        return acc;
      }, {})
    );

    if (!dataToExport.length) {
      message.warning("Aucune donnée à exporter");
      return;
    }
    printpdf('/Print/Exports/Tab/List_fournisseurs')
    // printJS({
    //   printable: dataToExport,
    //   properties: columnsToUse,
    //   type: "json",
    //   header: "Liste des fournisseurs",
    // });
  };

  const exportMenu = (
    <Menu
      onClick={({ key }) => {
        if (key === "excel") {
          handleExport();
        }
        if (key === "pdf") {
          handleExportPdf();
        }
      }}
    >
      <Menu.Item key="excel">Excel</Menu.Item>
      <Menu.Item key="pdf">PDF</Menu.Item>
    </Menu>
  );

  useEffect(() => {
    let updatedData = [];
    if (selectedOption === "a") {
      updatedData = tableData;
    } else if (selectedOption === "b") {
      updatedData = tableData.filter((item) => item.statut === "A");
    } else if (selectedOption === "c") {
      updatedData = tableData.filter((item) => item.statut === "S");
    } else if (selectedOption === "d") {
      updatedData = tableData.filter((item) => item.agree === "A");
    } else if (selectedOption === "e") {
      updatedData = tableData.filter((item) => item.agree === "N");
    }

    if (selectedType) {
      updatedData = updatedData.filter((item) => item.codespe === selectedType);
    }

    if (searchText.trim()) {
      const normalizedSearch = searchText.toLowerCase().trim();
      updatedData = updatedData.filter((item) =>
        Object.values(item).some(
          (val) =>
            val && val.toString().toLowerCase().includes(normalizedSearch)
        )
      );
    }

    setFilteredData(updatedData);
    setTotalFournisseurs(updatedData.length); // Mise à jour du total fournisseurs filtré
  }, [selectedOption, tableData, selectedType, searchText]);

  // Styles dynamiques des boutons de filtre en fonction des badges (Etat/Agree)
  const getFilterBtnGradient = (value) => {
    switch (value) {
      case "b": // Actifs (Etat A)
        return "linear-gradient(135deg, #67f02e 0%, #4cd137 100%)";
      case "c": // Suspendus (Etat S)
        return "linear-gradient(135deg, #d92316 0%, #ff6b6b 100%)";
      case "d": // Agrées (Agree A)
        return "linear-gradient(135deg, #67f02e 0%, #4cd137 100%)";
      case "e": // Non agrées (Agree N)
        return "linear-gradient(135deg, #e0ce07 0%, #f9e94d 100%)";
      default:
        return "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)"; // Bleu par défaut
    }
  };

  const getFilterBtnShadow = (value) => {
    switch (value) {
      case "b":
        return "0 3px 10px rgba(103, 240, 46, 0.4)";
      case "c":
        return "0 3px 10px rgba(217, 35, 22, 0.4)";
      case "d":
        return "0 3px 10px rgba(103, 240, 46, 0.4)";
      case "e":
        return "0 3px 10px rgba(224, 206, 7, 0.4)";
      default:
        return "0 3px 10px rgba(24, 144, 255, 0.4)";
    }
  };

  const getFilterLabel = (value) => {
    const filterMap = {
      "a": "Tous",
      "b": "Actifs",
      "c": "Suspendus",
      "d": "Agrées",
      "e": "Non agrées",
    };
    return filterMap[value] || "Tous";
  };

  const columns = [
    {
      title: "Numéro",
      dataIndex: "numFourn",
      align: "center",
      key: "numFourn",
      fixed: "left",
      className: "small-cell",
      ellipsis: true,
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
          <span style={{ fontWeight: 500 }}>{text || " "}</span>
          {userProfil !== "Point Focal" && (
            <Tooltip title="Éditer ce fournisseur">
              <ArrowRightOutlined
                style={{
                  cursor: "pointer",
                  color: "#1890ff",
                  fontSize: 12,
                  transition: "color 0.2s",
                }}
                onClick={() => {
                  navigate(`/fournisseurs/view/${record.numFourn}`);
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = "#40a9ff";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "#1890ff";
                }}
              />
            </Tooltip>
          )}
        </div>
      ),
      sorter: (a, b) => (a.numFourn || "").localeCompare(b.numFourn || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            paddingLeft: 5,
          }}
        >
          Raison Sociale
        </div>
      ),
      dataIndex: "raisoc",
      key: "raisoc",
      className: "small-cell",
      ellipsis: true,
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "left", paddingRight: 5, paddingLeft: 5 }}>
          {text || " "}
        </div>
      ),
      sorter: (a, b) => (a.raisoc || "").localeCompare(b.raisoc || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            paddingLeft: 5,
          }}
        >
          Adresse
        </div>
      ),
      dataIndex: "adresse",
      key: "adresse",
      className: "small-cell",
      ellipsis: true,
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "left", paddingRight: 5, paddingLeft: 5 }}>
          {text || " "}
        </div>
      ),
      sorter: (a, b) => (a.adresse || "").localeCompare(b.adresse || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Fixe.",
      dataIndex: "telFix",
      key: "telFix",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => (a.telFix || "").localeCompare(b.telFix || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Portable",
      dataIndex: "portable",
      key: "portable",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => (a.portable || "").localeCompare(b.portable || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Agréé",
      dataIndex: "agree",
      key: "agree",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      render: (agree) => {
        let color = "";
        let text = "";

        if (agree === "A") {
          color = "#67f02e";
          text = "A";
        }
        else if (agree === "N") {
          color = "#e0ce07";
          text = "N";
        } else if (agree === "C") {
          color = "#e0ce07";
          text = "C";
        } else if (agree === "R") {
          color = "#d92316";
          text = "R";
        }

        return (
          <Tag color={color} key={agree}>
            {text}
          </Tag>
        );
      },
      sorter: (a, b) => (a.agree || "").localeCompare(b.agree || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Etat",
      dataIndex: "statut",
      key: "statut",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      render: (statut) => {
        let color = "";
        let text = "";

        if (statut === "A") {
          color = "#67f02e";
          text = "A";
        } else if (statut === "S") {
          color = "#d92316";
          text = "S";
        }

        return (
          <Tag color={color} key={statut}>
            {text}
          </Tag>
        );
      },
      sorter: (a, b) => (a.statut || "").localeCompare(b.statut || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            paddingLeft: 5,
          }}
        >
          Specialité
        </div>
      ),
      dataIndex: "intitule",
      key: "intitule",
      className: "small-cell",
      ellipsis: true,
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "left", paddingRight: 5, paddingLeft: 5 }}>
          {text || "N/A"}
        </div>
      ),
      sorter: (a, b) => (a.intitule || "").localeCompare(b.intitule || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      // title: "Créer le",
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            paddingLeft: 5,
          }}
        >
          Créer le
        </div>
      ),
      dataIndex: "dateCreation",
      key: "dateCreation",
      align: "center",
      render: (text) => text ? moment(text).format("DD/MM/YYYY") : "",
    },
    {
      //  title: "Saisie par",
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            paddingLeft: 5,
          }}
        >
          Saisie par
        </div>
      ),
      dataIndex: "created_by",
      key: "created_by",
      align: "center",

    },

    ...(userProfil !== 'Point Focal' ? [ // Ajoute les actions uniquement pour les profils autres que 'role_15', 'role_3', 'role_4' et 'role_5'
      {
        title: (
          <div
            style={{
              backgroundColor: " #010f1c",
              color: "white",
              padding: "1px",
            }}
          ></div>
        ),
        className: "small-cell",
        ellipsis: true,
        dataIndex: "actions",
        key: "actions",
        align: "center",
        fixed: "right",
        render: (text, record) => (
          <span>
            <Space>
              <Tooltip title="Afficher">
                <Link to={`/fournisseurs/view/${record.numFourn}`}>
                  <EyeOutlined style={{ cursor: "pointer", color: "#67f02e", marginRight: 8 }} />
                </Link>
              </Tooltip>
              <Tooltip title="Modifier">
                <Link to={`/fournisseurs/edit/${record.numFourn}`}>
                  <EditOutlined
                    onClick={() => handleEdit(record)}
                    style={{ cursor: "pointer", color: "#1890ff", marginRight: 8 }}
                  />
                </Link>
              </Tooltip>
              <Popconfirm
                title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
                onConfirm={() => handleDelete(record)}
                okText="Oui"
                cancelText="Non"
              >
                <Tooltip title="Supprimer">
                  <DeleteFilled style={{ cursor: "pointer", color: "red" }} />
                </Tooltip>
              </Popconfirm>
            </Space>
          </span>
        ),
      },
    ] : []),
  ];

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xs={24} xl={24}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={10} lg={10}>
              <label style={{ fontSize: "16px", fontWeight: "600", color: "#173beb", marginBottom: "12px", display: "block", letterSpacing: "0.5px" }}>
                📊 Total fournisseurs <span style={{ color: "#666", fontSize: "14px", fontWeight: "500" }}>({getFilterLabel(selectedOption)})</span> : <span style={{ color: "#000", fontSize: "18px", fontWeight: "700" }}>{totalFournisseurs}</span>
              </label>
              <Row gutter={8} align="middle">
                <Col xs={12}>
                  <Input
                    className="search-input-highlight"
                    placeholder="Rechercher..."
                    allowClear
                    prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
                    value={searchText}
                    style={{ width: "100%" }}
                    onChange={(e) => handleSearch(e.target.value)}
                    onPressEnter={(e) => handleSearch(e.target.value)}
                  />
                </Col>
                <Col xs={12}>
                  <Select
                    value={selectedType}
                    onChange={(value) => {
                      setSelectedType(value);
                    }}
                    className="select-colored-accent"
                    style={{
                      width: "100%",
                      "--select-accent": "#1890ff",
                      "--select-accent-bg": "#e6f4ff",
                      "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
                    }}
                    showSearch
                  >
                    <Select.Option value={""}>Toutes les specialités</Select.Option>
                    {specialites.map((specialite) => (
                      <Select.Option
                        key={`${specialite.codespe} ${specialite.intitule}`}
                        value={specialite.codespe}
                      >
                        {`${specialite.codespe} ${specialite.intitule}`}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={14} lg={14}>
              <Row justify="space-between" align="middle">
                <Col span={24} style={{ textAlign: "right" }}>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: "1rem", justifyContent: "flex-end" }}>
                    {[
                      { value: "a", label: "Tous" },
                      { value: "b", label: "Actifs" },
                      { value: "c", label: "Suspendus" },
                      { value: "d", label: "Agrées" },
                      { value: "e", label: "Non agrées" },
                    ].map((item) => (
                      <button
                        key={item.value}
                        onClick={() => setSelectedOption(item.value)}
                        style={{
                          padding: "6px 14px",
                          borderRadius: 20,
                          border: "none",
                          cursor: "pointer",
                          fontSize: 13,
                          fontWeight: 500,
                          transition: "all 0.3s ease",
                          background: selectedOption === item.value
                            ? getFilterBtnGradient(item.value)
                            : "#f0f0f0",
                          color: selectedOption === item.value ? "#fff" : "#595959",
                          boxShadow: selectedOption === item.value
                            ? getFilterBtnShadow(item.value)
                            : "0 1px 3px rgba(0, 0, 0, 0.1)",
                        }}
                        onMouseEnter={(e) => {
                          if (selectedOption !== item.value) {
                            e.currentTarget.style.background = "#e0e0e0";
                            e.currentTarget.style.transform = "translateY(-1px)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (selectedOption !== item.value) {
                            e.currentTarget.style.background = "#f0f0f0";
                            e.currentTarget.style.transform = "translateY(0)";
                          }
                        }}
                      >
                        {item.label}
                      </button>
                    ))}
                  </div>
                </Col>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Space style={{ display: "flex", justifyContent: "flex-end" }}>
                    {showCreateDivButton && (
                      <Button
                        size="small"
                        icon={<PlusCircleFilled />}
                        style={{ backgroundColor: "#173beb", color: "white" }}
                        onClick={handleShowCreaFournDiv}
                      >
                        Créer Fourn Div
                      </Button>
                    )}
                    <Dropdown overlay={exportMenu} placement="bottomRight">
                      <Button
                        size="small"
                        icon={<ExportOutlined />}
                        className="buttonExport"
                      >
                        Exporter
                      </Button>
                    </Dropdown>
                    <Button
                      onClick={handleResetAll}
                      icon={<SyncOutlined />}
                      size="small"
                      className="buttonRefresh"
                    >
                      Actualiser
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Col>
          </Row>
          <Card bordered={false}>
            {editModalVisible && selectedRowForEdit && (
              <EditFournisseur
                visible={editModalVisible}
                onCancel={() => setEditModalVisible(false)}
                onOk={() => setEditModalVisible(false)}
                selectedRowForEdit={selectedRowForEdit}
              //onUpdate={fetchData}
              />
            )}
            <Table
              rowKey={(record) => record.numFourn}
              scroll={{
                x: true,
              }}
              showSorterTooltip={false}
              style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
              pagination={{
                pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
                showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
                pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
                onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
              }}
              className="custom-header1-table"
              bordered

              columns={columns}
              dataSource={filteredData}
              loading={loading}
              onRow={(record, rowIndex) => ({
                onClick: (event) => {
                  // Vérifier si l'élément cliqué est l'icône de modification
                  const isEditIconClicked = event.target.tagName === "svg" && event.target.getAttribute("aria-label") === "Modifier";

                  // Si c'est l'icône de modification, appeler handleEdit
                  if (isEditIconClicked) {
                    handleEdit(record);
                  }
                }
              })}

            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ListFournis;
